import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import ModalWindow from "../ModalWindow.vue";
import Messages from "./Messages.vue";
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MessageModal',
    props: {
        fromUserId: {},
        toUserId: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const show = ref(false);
        const props = __props;
        const emits = __emit;
        const close = () => {
            show.value = false;
            emits("close");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalWindow, {
                "is-visible": show.value,
                onClose: close
            }, {
                header: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("h3", null, "メッセージ", -1)
                ])),
                default: _withCtx(() => [
                    _createVNode(Messages, {
                        "from-user-id": props.fromUserId,
                        "to-user-id": props.toUserId
                    }, null, 8, ["from-user-id", "to-user-id"])
                ]),
                _: 1
            }, 8, ["is-visible"]));
        };
    }
});
